import React from 'react';
import { toAbsoluteUrl } from '../../_metronic/helpers/AssetHelpers';

export function LoadingScreen() {
    return (
        <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <img src={toAbsoluteUrl('/media/gif/loading.gif')} alt="Loading..." className='img-fluid' />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}

    </div>
    );
}